var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    attrs: {
      title: _vm.$t("FiberCircuit"),
      "pos-x": _vm.position.x,
      "pos-y": _vm.position.y,
      height: 139,
      width: _vm.width,
      "is-resizing": true,
      circuit: _vm.circuit
    },
    on: {
      close: _vm.close,
      changePosition: function($event) {
        return _vm.$emit("changeClusterWindowsPosition", $event)
      },
      changeSize: function($event) {
        return _vm.changeSize($event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [
            _c("v-icon", { staticClass: "pr-2" }, [
              _vm._v("settings_input_composite")
            ])
          ]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c("v-card", { attrs: { loading: _vm.loading } }, [
              _c("div", { staticClass: "floating-tool-content" }, [
                _c("div", { staticClass: "scroll-fire-fox" }, [
                  _c(
                    "div",
                    { staticStyle: { "text-align": "left", margin: "0" } },
                    [
                      _c("label", [
                        _vm._v(" " + _vm._s(_vm.$tc("Circuit", 1)) + ": ")
                      ]),
                      _vm._v(" "),
                      _c("treeselect", {
                        attrs: {
                          options: _vm.allCircuits,
                          normalizer: _vm.listElementNormalizer,
                          "load-options": _vm.getFiberCircuit,
                          disableFuzzyMatching: "",
                          clearable: false,
                          valueFormat: "object",
                          disabled: _vm.loading
                        },
                        model: {
                          value: _vm.circuit,
                          callback: function($$v) {
                            _vm.circuit = $$v
                          },
                          expression: "circuit"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.circuit
                    ? _c(
                        "div",
                        { staticClass: "floating-objects-wrapper" },
                        [
                          _c("label", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("LossValue")) +
                                ": " +
                                _vm._s(_vm.circuit.loss_value.toFixed(2)) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.circuit.circuit, function(object) {
                            return _c(
                              "v-layout",
                              {
                                key: object.uuid,
                                staticStyle: {
                                  "margin-bottom": "5px",
                                  "margin-top": "5px"
                                },
                                attrs: {
                                  row: "",
                                  "align-center": "",
                                  "justify-start": ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "floating-object-selected",
                                    staticStyle: { width: "100%" }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: {
                                          width: "20%",
                                          "text-align": "-webkit-center"
                                        }
                                      },
                                      [
                                        object.subtype === "fc_port" &&
                                        object.type === "node"
                                          ? _c("div", {
                                              staticClass: "port-object"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        object.subtype === "fc_fiber" ||
                                        object.subtype === "fc_cable"
                                          ? _c("div", {
                                              staticClass: "cable-fiber-object",
                                              style: {
                                                height: _vm.getHeightCable(
                                                  object
                                                ),
                                                "margin-top": _vm.getMarginTopCable(
                                                  object
                                                ),
                                                "margin-bottom": _vm.getMarginBottomCable(
                                                  object
                                                )
                                              }
                                            })
                                          : _c(
                                              _vm.getImageName(object.subtype),
                                              {
                                                tag: "component",
                                                staticClass: "floating-img",
                                                staticStyle: { "z-index": "2" }
                                              }
                                            )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: {
                                          width: "80%",
                                          "text-align": "initial"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "fiber-circuit-item" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "fiber-circuit-select":
                                                    object.uuid ===
                                                    _vm.fiberUuid
                                                },
                                                staticStyle: {
                                                  "text-align": "left",
                                                  "line-height": "1",
                                                  "word-break": "break-all"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getObjectLabel(object)
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            object.subtype === "fc_fiber"
                                              ? _c(
                                                  "span",
                                                  { staticClass: "grey--text" },
                                                  [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(
                                                          object.loss_value.toFixed(
                                                            2
                                                          )
                                                        ) +
                                                        ")"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93b12b36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93b12b36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/FiberCircuit/FiberCircuitWindow.vue
// module id = null
// module chunks = 